import { FunctionComponent, useState, useEffect, useMemo, useRef, useReducer } from 'react'
import { Box, Typography, Avatar, Select, MenuItem, makeStyles } from '@material-ui/core'
import { Modal } from 'components/core/modal'
import { BackendUser } from 'common/types'
import { ReactComponent as DeletePreviewIcon } from 'icons/delete-preview.svg'
import { ElasticSlider } from 'components/core/slider/ElasticSlider'
import { AddMedia } from '../AddMedia'
import {
  BackendContent,
  Content,
  CREATE_POST_DESCRIPTION_PLACEHOLDER,
  CREATE_POST_TITLE_PLACEHOLDER,
  CursorElement,
  PostTypes
} from 'common/types/content.types'
import ReactWebMediaPlayer from 'react-web-media-player'
//@ts-ignore
import { useTheme } from 'styled-components'
import styled from 'styled-components/macro'
import { SharedPostCard } from '../SharedPostCard'
import { useFormatHours } from 'hooks/use-format-hours/useFormatHours'
import { useCreatePost } from 'pages/content/hooks/useCreatePost'
import { KeyboardArrowDown } from '@material-ui/icons'
import { StyledEventButton } from 'pages/administration/components/create-event/styles'
import { MentionsTextfield } from './MentionsTextField'
import { IMentionsState } from 'common/types/mentions.types'
import { useMentions } from '../hooks/useMentions'
import { MentionsSuggestionsList } from './MentionsSuggestionsList'
import { getHTMLTextLength } from 'common/utils/getHTMLTextLength'
import handleLongText from 'common/utils/handleLongText'
import { createMentionsState } from 'common/utils/createMentionsState'
import { getMentionsTags } from 'common/utils/getMentionsTags'
import { DEV_ONLY } from 'common/globalConstants'
import { findHashtag } from 'common/utils/findHashtag'
import { removeHashtagLinks } from 'common/utils/removeHashtagLinks'
import { ThemeModal } from 'components/core/ThemeModal/ThemeModal'
import { useNotification } from 'hooks/use-notification/useNotification'
import { extractHashtags } from 'common/utils/addHashtagLinks'
import { useLocation } from 'react-router-dom'
import { useCreatePostModal } from '../hooks/useCreatePostModal'
import { Button } from 'common/atoms/Button/Button'

export const StyledBox = styled(Box)`
  && {
    box-shadow: 0 0 0 0 ${props => props.theme.colors.primary};
    width: 100%;
    height: 30em;
    position: relative;
  }
`

export const StyledDescriptionBox = styled(Box)`
  && {
    border: 2px solid ${props => props.theme.colors.accent1};
    border-radius: 6px;
  }
`
const StyledMediaBox = styled(Box)`
  background: ${props => props.theme.colors.supplementary1};
  border-radius: 15px;
`

const StyledSelect = styled(Select)`
  && {
    border: 2px solid ${props => props.theme.colors.accent};
    background-color: ${props => props.theme.colors.bgPrimary};
  }
`

interface CreatePostModalProps {
  onClose: () => void
  show: boolean
  setShow: Function
  setShowSuccessChip?: Function
  title: string
  user?: BackendUser
  edit?: boolean
  noborder: boolean
  createContent?: Function
  updateContent?: Function
  updateContentActivity?: Function
  setShowEdit?: Function
  setPosts?: Function
  setPost?: Function
  posts?: Content[]
  myPosts?: Content[]
  setMyPosts?: Function
  setShowLoader: Function
  postId?: string
  postToEdit?: Content
  postEdited?: boolean
  parseContentBody?: Function
  displayShowMore?: Function
  hideFeed?: boolean
  postAsPartner?: boolean
  postAsMember?: boolean
}

export const CreatePostModal: FunctionComponent<CreatePostModalProps> = ({
  onClose,
  show,
  setShow,
  setShowSuccessChip,
  title,
  user,
  edit,
  noborder,
  createContent,
  updateContent,
  updateContentActivity,
  setPosts,
  setPost,
  posts,
  myPosts,
  setMyPosts,
  setShowLoader,
  postId,
  postToEdit,
  postEdited,
  parseContentBody,
  displayShowMore,
  hideFeed,
  postAsPartner,
  postAsMember
}) => {
  const {
    theme,
    isDevice,
    getProcessedFile,
    maxTitleLength,
    maxDescriptionLength,
    maxVideoFileSize,
    maxImageFileSize,
    setCursorPos,
    cursorEl,
    setCursorEl,
    setPostDescription,
    setPostTitle,
    previewImage,
    setPreviewImage,
    postImages,
    setPostImages,
    previewVideo,
    setPreviewVideo,
    postVideo,
    setPostVideo,
    showMediaError,
    setShowMediaError,
    imageUploaded,
    setImageUploaded,
    videoUploaded,
    setVideoUploaded,
    newUploads,
    setNewUploads,
    media,
    previewMedia,
    post,
    mediaCategory,
    getPostDetails,
    isImage,
    isVideo,
    picturesChanged,
    clearPost,
    getErrorMessage,
    backendUser,
    backendPartner,
    history,
    backendUserFunctions
  } = useCreatePost()
  const {
    isPostingContent,
    clearLocalData,
    setPostAs,
    renderStaticUserInfo,
    userHeadline,
    postAs,
    postPermission,
    handleChange,
    classes,
    getResults,
    setMentions,
    setUsers,
    titleTextfieldId,
    setTextfieldCharacterLength,
    users,
    setTitleTextfieldValue,
    totalSuggestions,
    mentionedCounter,
    setMentionedCounter,
    resetMentioningRef,
    isMentioning,
    setIsMentioning,
    titleTextfieldValue,
    mentions,
    tags,
    textfieldCharacterLength,
    descriptionMentionsState,
    descriptionStateDispatch,
    setTagResults,
    descriptionResetMentioningRef,
    changesMade,
    handlePost,
    setIsPostingContent,
    tagResults,
    searchText,
    setTags
  } = useCreatePostModal(
    backendUserFunctions,
    postAsPartner,
    backendUser,
    postToEdit,
    backendPartner,
    postAsMember,
    getPostDetails,
    isVideo,
    setPreviewVideo,
    setPreviewImage,
    setVideoUploaded,
    isImage,
    setPostImages,
    setImageUploaded,
    show,
    picturesChanged,
    previewImage,
    previewVideo,
    maxTitleLength,
    maxDescriptionLength,
    postImages,
    newUploads,
    imageUploaded,
    videoUploaded,
    media,
    previewMedia,
    mediaCategory,
    postVideo,
    post,
    edit,
    postId,
    updateContent,
    useFormatHours,
    updateContentActivity,
    createContent,
    posts,
    hideFeed,
    setPosts,
    setPost,
    setShowLoader,
    myPosts,
    setMyPosts,
    setShow,
    clearPost,
    setCursorPos,
    setCursorEl,
    setPostTitle,
    setPostDescription,
    cursorEl,
    theme
  )

  const renderVideo = useMemo(
    () => (
      <Box height="auto" width="100%" position="relative" zIndex="0">
        <Box position="absolute" top="1em" right="1em" zIndex="1">
          <DeletePreviewIcon
            onClick={() => {
              previewVideo.shift()
              setPreviewVideo([...previewVideo])
              postVideo.shift()
              setPostVideo([...postVideo])
              if (previewVideo.length === 0) setVideoUploaded(false)
            }}
          />
        </Box>
        <ReactWebMediaPlayer video={previewVideo} width="100%" color="#7E45C4" />
      </Box>
    ),
    [previewVideo]
  )

  const renderProfileComponent = (type: string) => {
    if (type === 'Member') {
      return (
        <Box display="flex">
          <Avatar src={user?.image} alt="member with a profile" style={{ width: '1.6em', height: '1.6em' }} />
          <Typography variant="subtitle1" align="left">
            <Box ml="0.5em"> {handleLongText({ text: `${user?.firstName} ${user?.lastName}`, count: 25 })}</Box>
          </Typography>
        </Box>
      )
    } else if (type === 'Partner') {
      return (
        <Box display="flex">
          <Avatar src={backendPartner?.logo} alt="company logo" style={{ width: '1.6em', height: '1.6em' }} />
          <Typography variant="subtitle1" align="left">
            <Box ml="0.5em"> {handleLongText({ text: backendPartner?.name, count: 25 })}</Box>
          </Typography>
        </Box>
      )
    } else {
      return ''
    }
  }

  return (
    <>
      <ThemeModal loading={isPostingContent} />
      <Modal
        showCancel
        show={show}
        onClose={() => {
          clearLocalData()
          setShow(false)
          clearPost()
          if (!edit) setShowSuccessChip(false)
          setPostAs('')
        }}
        title={title}
        noBorder={noborder}
        dialogWidth="xl"
      >
        <Box
          display="flex"
          flexDirection="column"
          width={isDevice ? '32em' : '48em'}
          padding={isDevice ? '0 1em 0 0' : '0 1em'}
        >
          {renderStaticUserInfo() && (
            <Box display="flex">
              <Avatar
                src={postAsPartner || postAs === 'Partner' ? backendPartner?.logo : user?.image}
                alt="member with a profile"
                style={{ width: '3em', height: '3em' }}
              ></Avatar>
              <Box margin={userHeadline ? '0.5em 0 2em 1em' : '1em 0 2em 1em'} color={theme.colors.accent1}>
                <Typography variant="subtitle1" align="left">
                  {!postAsPartner && postAs !== 'Partner' && (
                    <Box fontWeight="bold"> {`${user?.firstName} ${user?.lastName}`}</Box>
                  )}
                  {(postAsPartner || postAs === 'Partner') && <Box fontWeight="bold">{backendPartner?.name}</Box>}
                </Typography>
                {!postAsPartner && postAs !== 'Partner' && (
                  <>
                    <Typography
                      gutterBottom
                      variant="subtitle2"
                      component="span"
                      align="left"
                      style={{ wordWrap: 'break-word' }}
                    >
                      <Box fontWeight="bold" color={theme.colors.accent} display="inline">
                        {userHeadline?.slice(0, 45)}
                      </Box>
                    </Typography>
                    {userHeadline?.length > 45 && (
                      <Typography variant="subtitle2" style={{ display: 'contents' }}>
                        ...
                      </Typography>
                    )}
                  </>
                )}
              </Box>
            </Box>
          )}
          {!postAsMember && !edit && backendPartner && !postAsPartner && postPermission && (
            <Box mb="1.5em">
              <StyledSelect
                disableUnderline
                displayEmpty
                fullWidth
                value={renderProfileComponent(postAs)}
                renderValue={value => (value ? value : <Box color={theme.colors.accent}>Please Select Profile</Box>)}
                onChange={e => handleChange(e, 'profile')}
                IconComponent={props => <KeyboardArrowDown {...props} className={classes.dropDown} />}
                MenuProps={{
                  classes: { paper: classes.select },
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                  },
                  getContentAnchorEl: null
                }}
              >
                <MenuItem value="Member">
                  <Box display="flex">
                    <Avatar src={user?.image} alt="member with a profile" style={{ width: '1.6em', height: '1.6em' }} />
                    {(user?.firstName + user?.lastName).length > 14 && (
                      <Typography variant="subtitle2" align="left">
                        <Box ml="0.5em"> {`${(user?.firstName + ' ' + user?.lastName).slice(0, 14)}...`}</Box>
                      </Typography>
                    )}
                    {(user?.firstName + user?.lastName).length <= 14 && (
                      <Typography variant="subtitle2" align="left">
                        <Box ml="0.5em"> {`${user?.firstName} ${user?.lastName}`}</Box>
                      </Typography>
                    )}
                  </Box>
                </MenuItem>
                <MenuItem value="Partner">
                  <Box display="flex">
                    <Avatar src={backendPartner?.logo} alt="company logo" style={{ width: '1.6em', height: '1.6em' }} />
                    {(backendPartner?.name).length > 14 && (
                      <Typography variant="subtitle2" align="left">
                        <Box ml="0.5em"> {`${(backendPartner?.name).slice(0, 14)}...`}</Box>
                      </Typography>
                    )}
                    {(backendPartner?.name).length <= 14 && (
                      <Typography variant="subtitle2" align="left">
                        <Box ml="0.5em"> {`${backendPartner?.name}`}</Box>
                      </Typography>
                    )}
                  </Box>
                </MenuItem>
              </StyledSelect>
            </Box>
          )}
          <Box
            padding={userHeadline ? '0.5em 0 1em 0' : '1em 0'}
            width="100%"
            display="flex"
            flexDirection="column"
            position="relative"
          >
            {postToEdit?.type !== 'share' && postToEdit?.type !== 'activity' && (
              <>
                <Box
                  className="MuiInputBase-root MuiInput-root MuiInputBase-fullWidth MuiInput-fullWidth MuiInputBase-formControl MuiInput-formControl MuiInputBase-adornedEnd"
                  padding="14px"
                  display="flex"
                  justifyContent="space-between"
                >
                  <MentionsTextfield
                    mentioningActive={false}
                    getResults={getResults}
                    maxLength={maxTitleLength}
                    mentionedContainerClass="title-mentioned"
                    setMentions={setMentions}
                    setUsers={setUsers}
                    typingID={titleTextfieldId}
                    setCursorEl={(active: boolean) => {
                      setCursorEl(active ? CursorElement.TITLE : null)
                    }}
                    setCharacterCount={characterLength => {
                      setTextfieldCharacterLength(characterLength)
                    }}
                    users={cursorEl === CursorElement.TITLE ? users : []}
                    singleLine={true}
                    edit={edit}
                    theme={theme}
                    setText={text => setTitleTextfieldValue(text || '')}
                    totalSuggestions={totalSuggestions}
                    mentionedCounter={mentionedCounter}
                    setMentionedCounter={setMentionedCounter}
                    resetMentioningRef={resetMentioningRef}
                    isMentioning={isMentioning}
                    setIsMentioning={setIsMentioning}
                    placeholder={CREATE_POST_TITLE_PLACEHOLDER}
                    defaultValue={titleTextfieldValue}
                    mentions={mentions}
                    tags={tags}
                  />
                  <Box
                    padding="0 0.5em"
                    color={textfieldCharacterLength >= maxTitleLength ? theme.colors.error : theme.colors.accent1}
                  >
                    <Typography variant="body2">
                      {textfieldCharacterLength}/{maxTitleLength}
                    </Typography>
                  </Box>
                </Box>
                <MentionsSuggestionsList
                  value={titleTextfieldValue}
                  getResults={getResults}
                  mentionedContainerClass="title-mentioned"
                  mentionedCounter={mentionedCounter}
                  resetMentioningRef={resetMentioningRef}
                  setMentions={setMentions}
                  setText={text => {
                    setTitleTextfieldValue(text)
                  }}
                  setCharacterCount={characterLength => {
                    setTextfieldCharacterLength(characterLength)
                  }}
                  totalSuggestions={totalSuggestions}
                  typingID={titleTextfieldId}
                  users={cursorEl === CursorElement.TITLE ? users : []}
                  isMentioning={isMentioning}
                />
              </>
            )}
          </Box>
          <Box padding="1em 0" width="100%" display="flex" flexDirection="column">
            <StyledDescriptionBox display="flex" flexDirection="column">
              <Box className="MuiFormControl-root MuiTextField-root CreatePostModal__StyledTextField-sc-1vuuvjy-4 eyqQDS MuiFormControl-fullWidth">
                <Box
                  border="none !important"
                  className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-fullWidth MuiInput-fullWidth MuiInputBase-formControl MuiInput-formControl MuiInputBase-multiline MuiInput-multiline"
                >
                  <Box
                    border="none"
                    className="MuiInputBase-input MuiInput-input MuiInputBase-inputMultiline MuiInput-inputMultiline"
                  >
                    <MentionsTextfield
                      getResults={getResults}
                      maxLength={maxDescriptionLength}
                      height="20em"
                      mentionedContainerClass="description-mentioned"
                      setMentions={setMentions}
                      setUsers={setUsers}
                      typingID={descriptionMentionsState?.textfieldId}
                      setCursorEl={(active: boolean) => {
                        setCursorEl(active ? CursorElement.DESCRIPTION : null)
                      }}
                      setCharacterCount={characterLength => {
                        descriptionStateDispatch({ textfieldCharacterLength: characterLength })
                      }}
                      users={cursorEl === CursorElement.DESCRIPTION ? users : []}
                      edit={edit}
                      theme={theme}
                      setText={(val: string) => descriptionStateDispatch({ textfieldValue: val })}
                      totalSuggestions={totalSuggestions}
                      mentionedCounter={descriptionMentionsState?.mentionedCounter}
                      setMentionedCounter={newCounterValue =>
                        descriptionStateDispatch({ mentionedCounter: newCounterValue })
                      }
                      resetMentioningRef={descriptionResetMentioningRef}
                      isMentioning={descriptionMentionsState?.isMentioning}
                      setIsMentioning={(val: boolean) => descriptionStateDispatch({ isMentioning: val })}
                      placeholder={CREATE_POST_DESCRIPTION_PLACEHOLDER}
                      defaultValue={descriptionMentionsState?.textfieldValue}
                      fullWidth
                      width="100%"
                      isTagging={descriptionMentionsState?.isTagging}
                      setIsTagging={isTagging => descriptionStateDispatch({ isTagging })}
                      setTagResult={setTagResults}
                      hasTagActive={DEV_ONLY}
                      setHashCount={hashCount => descriptionStateDispatch({ hashCount })}
                      hashCount={descriptionMentionsState?.hashCount}
                      mentions={mentions}
                      tags={tags}
                      setAutoTag={autoTag => descriptionStateDispatch({ autoTag })}
                      setSelectedTarget={selectedTarget => descriptionStateDispatch({ selectedTarget })}
                      selectedTarget={descriptionMentionsState?.selectedTarget}
                      state={descriptionMentionsState}
                      stateDispatch={descriptionStateDispatch}
                    />
                    <MentionsSuggestionsList
                      value={descriptionMentionsState?.textfieldValue}
                      getResults={getResults}
                      mentionedContainerClass="description-mentioned"
                      mentionedCounter={descriptionMentionsState?.mentionedCounter}
                      resetMentioningRef={descriptionResetMentioningRef}
                      setMentions={setMentions}
                      setText={(val: string) => descriptionStateDispatch({ textfieldValue: val })}
                      setCharacterCount={characterLength => {
                        descriptionStateDispatch({ textfieldCharacterLength: characterLength })
                      }}
                      totalSuggestions={totalSuggestions}
                      typingID={descriptionMentionsState?.textfieldId}
                      users={cursorEl === CursorElement.DESCRIPTION ? users : []}
                      isMentioning={descriptionMentionsState?.isMentioning}
                      setTagResults={setTagResults}
                      isTagging={descriptionMentionsState?.isTagging}
                      tagResults={tagResults}
                      searchText={searchText}
                      setTags={setTags}
                      hasTagActive={DEV_ONLY}
                      hashCount={descriptionMentionsState?.hashCount}
                      setAutoTag={autoTag => descriptionStateDispatch({ autoTag })}
                      autoTag={descriptionMentionsState?.autoTag}
                      setSelectedTarget={selectedTarget => descriptionStateDispatch({ selectedTarget })}
                    />
                  </Box>
                </Box>
              </Box>
              {edit && (postToEdit?.type === 'share' || postToEdit?.type === 'activity') && (
                <SharedPostCard
                  //@ts-ignore
                  post={postToEdit?.content}
                  isDevice={isDevice}
                  theme={theme}
                  history={history}
                  postEdited={postEdited}
                  userId={user?.id}
                  parseContentBody={parseContentBody}
                  displayShowMore={displayShowMore}
                />
              )}
              <Box width="unset" display="flex" padding="0 1em" justifyContent="flex-end" alignItems="center">
                <Box
                  justifySelf="flex-end"
                  color={
                    descriptionMentionsState?.textfieldCharacterLength >= maxDescriptionLength
                      ? theme.colors.error
                      : theme.colors.accent1
                  }
                >
                  <Typography variant="body2">
                    {descriptionMentionsState?.textfieldCharacterLength}/{maxDescriptionLength}
                  </Typography>
                </Box>
              </Box>
            </StyledDescriptionBox>
            {/*  */}
            {showMediaError !== null && (
              <Box visibility={showMediaError ? 'visible' : 'hidden'} color={theme.colors.error}>
                <Typography component="p">
                  <Box component="span">
                    <sup>*</sup>
                    {getErrorMessage(showMediaError)}
                  </Box>
                </Typography>
              </Box>
            )}
          </Box>
          <Box padding="1em 0">
            {imageUploaded && (
              <ElasticSlider noAutoPlay>
                {previewImage?.map((preImg, i) => {
                  return (
                    <StyledBox>
                      <Box position="absolute" top="1em" right="1em" zIndex="0">
                        <DeletePreviewIcon
                          onClick={() => {
                            previewImage.splice(i, 1)
                            setPreviewImage([...previewImage])
                            postImages.splice(i, 1)
                            setPostImages([...postImages])
                            if (previewImage.length === 0) setImageUploaded(false)
                          }}
                        />
                      </Box>
                      <img src={preImg} alt="" object-fit="contain" style={{ width: '100%', height: '30em' }}></img>
                    </StyledBox>
                  )
                })}
              </ElasticSlider>
            )}

            {videoUploaded && renderVideo}
          </Box>
          <Box>
            <Button
              design='secondary'
              small
              onClick={(e: any) => handleChange(e, 'tag')}
            >
              Add Hashtag
            </Button>
          </Box>
          <Box
            width="100%"
            display="flex"
            padding="0"
            justifyContent="space-between"
            alignItems="center"
            marginTop="2.5em"
          >
            <StyledMediaBox display="flex" justifyContent="left" alignItems="center">
              {postToEdit?.type !== 'share' && postToEdit?.type !== 'activity' && (
                <AddMedia
                  handleChange={handleChange}
                  previewImage={previewImage}
                  setPreviewImage={setPreviewImage}
                  setShowMediaError={setShowMediaError}
                  postImages={postImages}
                  setPostImages={setPostImages}
                  getProcessedFile={getProcessedFile}
                  videoUploaded={videoUploaded}
                  maxImageFileSize={maxImageFileSize}
                  setPreviewVideo={setPreviewVideo}
                  setPostVideo={setPostVideo}
                  imageUploaded={imageUploaded}
                  setVideoUploaded={setVideoUploaded}
                  maxVideoFileSize={maxVideoFileSize}
                  setNewUploads={setNewUploads}
                />
              )}
            </StyledMediaBox>
            <Box display="flex" justifyContent="flex-end" width={isDevice ? '90%' : '100%'} padding="1em 0">
              <Box margin="1em 0em" padding={isDevice ? '0 0.5em' : '0 1em'} width="40%">
                <StyledEventButton
                  design='primary'
                  fullWidth
                  variant="contained"
                  disabled={changesMade()}
                  onClick={() => {
                    setIsPostingContent(true)
                    handlePost(user?.id)
                  }}
                >
                  {edit ? 'SAVE' : 'POST'}
                </StyledEventButton>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box></Box>
      </Modal>
    </>
  )
}
